type NCALayerCallback = (response: any) => void;

export default class NCALayer {
  private onopen: () => void;
  private onclose: () => void;
  private endpoint?: string;
  private callback: NCALayerCallback | null = null;
  socket!: WebSocket;

  constructor(onopen: () => void, onclose: () => void, endpoint?: string) {
    this.onopen = onopen;
    this.onclose = onclose;
    this.endpoint = endpoint;

    this.connect();
  }

  signXml(data: string): Promise<string> {
    return new Promise((resolve, reject) => {
      this.callback = this.__createPromiseCallback(resolve, reject);

      this.socket.send(
        JSON.stringify({
          method: "signXml",
          module: "kz.gov.pki.knca.commonUtils",
          args: ["PKCS12", "SIGNATURE", data, "", ""],
        })
      );
    });
  }

  signFile(data: string): Promise<string> {
    return new Promise((resolve, reject) => {
      this.callback = this.__createPromiseCallback(resolve, reject);

      this.socket.send(
        JSON.stringify({
          method: "createCMSSignatureFromBase64",
          module: "kz.gov.pki.knca.commonUtils",
          args: ["PKCS12", "SIGNATURE", data, true],
        })
      );
    });
  }

  signAuth(data: string): Promise<string> {
    return new Promise((resolve, reject) => {
      this.callback = this.__createPromiseCallback(resolve, reject);

      this.socket.send(
        JSON.stringify({
          method: "signXml",
          module: "kz.gov.pki.knca.commonUtils",
          args: ["PKCS12", "AUTH", data, "", ""],
        })
      );
    });
  }

  getKeyInfo(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.callback = this.__createPromiseCallback(resolve, reject);

      this.socket.send(
        JSON.stringify({
          method: "getKeyInfo",
          module: "kz.gov.pki.knca.commonUtils",
          args: ["PKCS12"],
        })
      );
    });
  }

  close(): void {
    this.socket.close();
  }

  connect(): void {
    this.socket = new WebSocket(this.endpoint || "wss://127.0.0.1:13579/");
    this.socket.onopen = this.onopen;
    this.socket.onclose = this.onclose;
    this.socket.onmessage = (event: MessageEvent) => {
      if (this.callback) {
        this.callback(JSON.parse(event.data));
        this.callback = null;
      }
    };
  }

  private __createPromiseCallback(
    resolve: (value: string) => void,
    reject: (reason?: any) => void
  ): NCALayerCallback {
    return (response: any) =>
      response && response.code === "200"
        ? resolve(response["responseObject"])
        : reject(response);
  }
}
